export default "__VITE_ASSET__BVT9jVME__"